import React, {createContext, useContext, useState} from "react";
import $ from "jquery";
import jwt_decode from "jwt-decode";
import {Redirect, Route} from "react-router-dom";
import packageJson from '../package.json';

const authContext = createContext();

const ENDPOINT_ROUTES = {
    origin: packageJson.development ? window.location.origin.replace(":"+window.location.port, ":3006") : window.location.origin,
    auth: ()=> ENDPOINT_ROUTES.origin+"/API/login/",
    users: (suffix)=>ENDPOINT_ROUTES.origin+"/API/users/"+(suffix ? suffix:""),
    getUsers : (buildingId)=>ENDPOINT_ROUTES.origin+"/API/"+buildingId+"/users",
    buildings: ()=>ENDPOINT_ROUTES.origin+"/API/buildings",
    calendarRoute: ()=> ENDPOINT_ROUTES.origin+`/API/building/calendar`,
    calendar: (start,end)=>ENDPOINT_ROUTES.origin+`/API/building/calendar/${start}/${end}`,
    building: (suffix)=>ENDPOINT_ROUTES.origin+"/API/building/" + (suffix ? suffix:""),
    videos: ()=>ENDPOINT_ROUTES.origin+"/API/videos/",
    video: (suffix)=>ENDPOINT_ROUTES.origin+"/API/video/" + (suffix ? suffix:""),
    uploadVideo: ()=>ENDPOINT_ROUTES.origin+"/API/uploadvideo/"
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getToken() {
    let name = "token=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return undefined;
}

function getUser(){
    const token = getToken();

    if(token) {
        return createUser(token);
    }
    else
        return null;
}

function createUser(token){
    let jwtUser = jwt_decode(token);

    return {
        id:jwtUser.id,
        building:jwtUser.building_id,
        buildings: jwtUser.buildings,
        role:jwtUser.role,
        iat:jwtUser.iat,
        token:token,
        isAdmin : jwtUser.role === "ADMIN",
        isManager : jwtUser.role === "MANAGER",
        isSteward: jwtUser.role === "STEWARD",
        hasBuilding : !!jwtUser.building_id
    }



}

export function useAuth() {
    return useContext(authContext);
}

export default function ProvideAuth({ children }) {
    const auth = useProvideAuth();
    return (
        <authContext.Provider value={auth}>
            {children}
        </authContext.Provider>
    );
}

export function PrivateRoute({ children, ...rest }) {
    let auth = useAuth();
    return (
        <Route
            {...rest}
            render={({ location }) => {
                return auth.user ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: {from: location}
                        }}
                    />
                )
            }
            }
        />
    );
}


function useProvideAuth() {
    const [user, setUser] = useState(getUser());


    const signin = (login, password, callback)=>{

        $.ajax({
            url:ENDPOINT_ROUTES.auth(),
            type:'POST',
            data: {
                login: login,
                password: password
            },
            success : function(result,status,xhr){
                setCookie("token", result, 30);
                setUser(createUser(result));
                callback({success:true})
            },
            error : function(xhr,status,error){
                callback({success:false});
            }
        });
    };

    const signout = cb => {
        setCookie("token", null, 0);
        setUser(null);
    };

    const getBuildings = (callback)=>{

        if(!callback)
            return;

        $.ajax({
            url:ENDPOINT_ROUTES.buildings(),
            type:'GET',
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: error});
            }
        });
    }

    const selectEvents = (dateFrom, dateTo, callback) => {
        if(!callback)
            return;

        $.ajax({
            url:ENDPOINT_ROUTES.calendar(dateFrom, dateTo),
            type:'GET',
            headers: { 'x-auth-token': user.token },
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: error});
            }
        });
    }

    const getBuilding = (id, callback)=>{
        if(!callback)
            return;

        $.ajax({
            url:ENDPOINT_ROUTES.building(id),
            type:'GET',
            headers: { 'x-auth-token': user.token },
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: error});
            }
        });
    }

    const getDocuments = (suffix, callback)=>{
        if(!callback)
            return;

        $.ajax({
            url:ENDPOINT_ROUTES.building(suffix),
            type:'GET',
            headers: { 'x-auth-token': user.token },
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: error});
            }
        });
    }

    const uploadFile = (suffix, formData, progressHandler, callback)=>{
        if(!callback)
            return;

        $.ajax({
            url:ENDPOINT_ROUTES.building(suffix),
            type:'POST',
            data:formData,
            processData: false,  // tell jQuery not to process the data
            contentType: false,
            headers: { 'x-auth-token': user.token },
            xhr: function () {
                let myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) {
                    myXhr.upload.addEventListener('progress', progressHandler, false);
                }
                return myXhr;
            },
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: xhr.responseText});
            }
        });
    }

    const downloadFile = (suffix, callback)=>{
        $.ajax({
            url:ENDPOINT_ROUTES.building(suffix),
            type:'GET',
            xhrFields:{
                responseType:'blob'
            },
            headers: { 'x-auth-token': user.token },
            success : function(blob,status,xhr){
                callback({success:true, content:blob})
            },
            error : function(xhr,status,error){
                callback({success: false, error: error});
            }
        });
    }

    const deleteFile = (suffix, callback)=>{
        $.ajax({
            url:ENDPOINT_ROUTES.building(suffix),
            type:'DELETE',
            headers: { 'x-auth-token': user.token },
            success : function(blob,status,xhr){
                callback({success:true, content:blob})
            },
            error : function(xhr,status,error){
                callback({success: false, error: error});
            }
        });
    }

    const addBuilding = (data,callback)=>{
        if(!callback)
            return;

        $.ajax({
            url:ENDPOINT_ROUTES.building(),
            type:'POST',
            data : data,
            headers: { 'x-auth-token': user.token },
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: xhr.responseText});
            }
        });
    }

    const sendEvent = (data, callback) => {
        if(!callback)
            return;

        $.ajax({
            url:ENDPOINT_ROUTES.calendarRoute(),
            type:'POST',
            data : data,
            headers: { 'x-auth-token': user.token },
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: xhr.responseText});
            }
        });
    }

    const removeEvent = (event, callback)=>{
        if(!callback)
            return;

        $.ajax({
            url:ENDPOINT_ROUTES.calendarRoute(),
            type:'DELETE',
            data : event,
            headers: { 'x-auth-token': user.token },
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: xhr.responseText});
            }
        });
    }

    const updateBuilding = (data, callback)=>{
        if(!callback)
            return;

        $.ajax({
            url:ENDPOINT_ROUTES.building(),
            type:'PUT',
            data : data,
            headers: { 'x-auth-token': user.token },
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: xhr.responseText});
            }
        });
    }

    const addEditManager = (data,edition, callback)=>{
        $.ajax({
            url:ENDPOINT_ROUTES.users(),
            type: edition ? 'PUT' : 'POST',
            data : data,
            headers: { 'x-auth-token': user.token },
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: xhr.responseText});
            }
        });
    }

    const deleteManager = (suffix, callback)=>{
        $.ajax({
            url:ENDPOINT_ROUTES.users(suffix),
            type: 'DELETE',
            headers: { 'x-auth-token': user.token },
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: xhr.responseText});
            }
        });
    }

    const getUsers = (buildingId, callback)=>{
        $.ajax({
            url:ENDPOINT_ROUTES.getUsers(buildingId),
            type:'GET',
            headers: { 'x-auth-token': user.token },
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: xhr.responseText});
            }
        });
    }

    const addMobileUsers = (data, callback)=>{
        $.ajax({
            url:ENDPOINT_ROUTES.building("users"),
            type:'POST',
            headers: { 'x-auth-token': user.token },
            data:data,
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: xhr.responseText});
            }
        });
    }

    const getVideos = (callback)=>{
        if(!callback)
            return;

        $.ajax({
            url:ENDPOINT_ROUTES.videos(),
            type:'GET',
            headers: { 'x-auth-token': user.token },
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: error});
            }
        });
    }

    const deleteVideo = (suffix, callback)=>{
        if(!callback)
            return;

        $.ajax({
            url:ENDPOINT_ROUTES.video(suffix),
            type:'DELETE',
            headers: { 'x-auth-token': user.token },
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: error});
            }
        });
    }

    const uploadVideo = (formData, progressHandler, callback)=>{
        $.ajax({
            url:ENDPOINT_ROUTES.uploadVideo(),
            type:'POST',
            data:formData,
            processData: false,  // tell jQuery not to process the data
            contentType: false,
            headers: { 'x-auth-token': user.token },
            xhr: function () {
                let myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) {
                    myXhr.upload.addEventListener('progress', progressHandler, false);
                }
                return myXhr;
            },success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: error});
            }
        });
    }

    const getNotifications = (suffix,callback)=>{
        if(!callback)
            return;

        $.ajax({
            url:ENDPOINT_ROUTES.building(suffix),
            type:'GET',
            headers: { 'x-auth-token': user.token },
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: error});
            }
        });
    }

    const deleteNotification = (suffix, callback)=>{
        $.ajax({
            url:ENDPOINT_ROUTES.building(suffix),
            type:'DELETE',
            headers: { 'x-auth-token': user.token },
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: error});
            }

        });
    }

    const addNotification = (formData,suffix, callback)=>{
        $.ajax({
            url:ENDPOINT_ROUTES.building(suffix),
            type:'POST',
            headers: { 'x-auth-token': user.token },
            data:formData,
            success : function(result,status,xhr){
                callback({success:true, content:result})
            },
            error : function(xhr,status,error){
                callback({success: false, error: xhr.responseText});
            }
        });
    }

    return {
        user,
        signin,
        signout,
        calendar : {
            select : selectEvents,
            save : sendEvent,
            remove: removeEvent
        },
        buildings : {
            get: getBuildings,
            getBuilding:getBuilding,
            getDocuments : getDocuments,
            add: addBuilding,
            update: updateBuilding,
            uploadFile : uploadFile,
            deleteFile: deleteFile,
            download: downloadFile,
            addEditManager : addEditManager,
            deleteManager : deleteManager,
            getUsers : getUsers,
            addMobileUsers : addMobileUsers,
        },
        videos : {
            add : uploadVideo,
            get: getVideos,
            delete :deleteVideo
        },
        notifications : {
            add : addNotification,
            get : getNotifications,
            delete : deleteNotification
        }
    };
}